import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import React, { useContext, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation, gql, useQuery, useLazyQuery, useApolloClient } from "@apollo/client";
import CheckOrderStatus from '../../utils/Status/CheckOrderStatus'
import CheckPaymentStatus from '../../utils/Status/CheckPaymentStatus'
import CheckRefundStatus from '../../utils/Status/CheckRefundStatus'
// import OrderDetails from './OrderDetails';
import UseCookie from '../../utils/cookies/useCookie';
import Colors from '../../utils/colors/Colors';
import { ThemeContext } from '../../context/Theme';
import { FaChevronRight } from "react-icons/fa";
import { FaArrowLeftLong } from "react-icons/fa6";
import moment from 'moment';
import { RiBarChart2Fill } from "react-icons/ri";
import { RiDiscountPercentFill } from "react-icons/ri";
import { FaListAlt } from "react-icons/fa";
import { MdDeliveryDining } from "react-icons/md";
import { RiShoppingBag4Fill } from "react-icons/ri";
import { FaLocationDot } from "react-icons/fa6";
import { useLocation } from 'react-router-dom';
import CheckPaymentMethod from '../../utils/Status/CheckPaymentMethod';
import { toast } from 'react-toastify';
import axios from 'axios';
import NestPassInVoiceTemplate from '../../ui-components/InVoiceTemplate/NestPassInVoiceTemplate'
import { renderToStaticMarkup } from 'react-dom/server';
import CheckOnlinePaymentStatus from '../../utils/Status/CheckOnlinePaymentStatus'
import CheckOnlinePaymentRefundStatus from '../../utils/Status/CheckOnlinePaymentRefundStatus'
import { QueryNestPass, QueryNestPassInvoice, QueryNestPassStats } from '../../apollo/queries';

const queryNestPass = gql`
  ${QueryNestPass}
`;

const queryNestPassStats = gql`
  ${QueryNestPassStats}
`;

const queryNestPassInvoice = gql`
  ${QueryNestPassInvoice}
`;

export default function NestPassHistory(props) {
  const client = useApolloClient();
  const scrollDivRef = useRef(null);
  const { systemThemeMode,appColorTheme, setAppColorTheme} = useContext(ThemeContext)
  const colors = Colors[appColorTheme=='systemDefault'?systemThemeMode:appColorTheme];   
  const { t } = useTranslation()

    const [nestPassDataStats, setNestPassDataStats] = useState([]);
    var [isLoading, setIsLoading] = useState(false);
    var [pageNumber,setPageNumber] = useState(1);

  var [locationInfo,setLocationInfo] = useState()
  var [isLoading, setIsLoading] = useState(false);
  var [pageNumber,setPageNumber] = useState(0);
  var [NestPassOrdersHistory, setNestPassOrdersHistory] = useState([]);
  var [orderDetails, setOrderDetails] = useState(false);
  var [selectedOrder, setSelectedOrder] = useState();
  const [loadingMore, setLoadingMore] = useState(false);
  const { setCustomCookie, getCustomCookie, removeCustomCookie, clearAllCookies } = UseCookie();
  const {pathname} = useLocation();


  // Refs to hold the latest values of pageNumber and isLoadingMore
  const pageNumberRef = useRef(pageNumber);
  const isLoadingMoreRef = useRef(loadingMore);

  // Update the refs whenever the state changes
  useEffect(() => {
    pageNumberRef.current = pageNumber;
  }, [pageNumber]);

  useEffect(() => {
    isLoadingMoreRef.current = loadingMore;
  }, [loadingMore]);


  const [fetchMore, { data:queryNestPassHistoryData, loading:ordersDataLoading, error }] = useLazyQuery(queryNestPass, {
    fetchPolicy: 'network-only',
    onCompleted: (fetchMoreResult) => {
      if(fetchMoreResult?.queryNestPass){
        NestPassOrdersHistory = NestPassOrdersHistory.concat(fetchMoreResult?.queryNestPass?.nestPassMemberships)
        setNestPassOrdersHistory(NestPassOrdersHistory);
        pageNumber = pageNumber + 1
        setPageNumber(pageNumber);
        }
        //console.log("🚀 ~ OrdersHistory ~ pageNumber:", pageNumber)
      isLoading = false
      setIsLoading(isLoading)
      setLoadingMore(false);
    },
  });

  const [getMoreNestPassOrderDetails, { data, loading, error: statsError }] = useLazyQuery(queryNestPassStats, {
    fetchPolicy: 'network-only',
    onCompleted: (fetchMoreResult) => {
      if(fetchMoreResult?.queryNestPassStats){
        setNestPassDataStats(fetchMoreResult?.queryNestPassStats)
        isLoading = false
        setIsLoading(isLoading)
      }
      isLoading = false
      setIsLoading(isLoading)
    },
  });

  // const { data, loading, error:orderDetailsError, fetchMore:getMoreNestPassOrderDetails } = useQuery(getOrderDetailsByOrderId,{ 
  //   variables:{
  //   "orderId": ""
  // }})

  useEffect(() => {
  }, [pathname]);
  
  useEffect(() => {
    if(props?.isChecked){
      initialDataload()
      getMoreNestPassOrderDetails()
    }
  },[props?.isChecked])

  const initialDataload = async()=>{
    window.scrollTo(0, 0);
    orderDetails = false;
    setOrderDetails(orderDetails);
    NestPassOrdersHistory = []
    setNestPassOrdersHistory(NestPassOrdersHistory);
    pageNumber = 0
    setPageNumber(pageNumber)
    setLoadingMore(true);
    isLoading = true
    setIsLoading(isLoading)
    try{
      fetchMore({
        variables: {
          "limit": 10 ,
          skip: 10 * pageNumber,
        },
      });
    }
    catch(error){
      isLoading = false
      setIsLoading(isLoading)
      setLoadingMore(false);
    }
  }

  React.useEffect(() => {
    if (!loading && data) {
    //   if(data?.items){
    //     sortedDisplayItems = [...data?.items]?.sort((a, b) => a?.sortOrder - b?.sortOrder);
    //     setSortedDisplayItems(sortedDisplayItems)
    //   }
    }
  }, [data, loading]);

  useEffect(() => {
    const divElement = scrollDivRef.current;
    if (divElement) {
      divElement.addEventListener('scroll', handleScroll);
    }
    return () => {
      if (divElement) {
        divElement.removeEventListener('scroll', handleScroll);
      }
    };
  }, [loadingMore]);

  const loadMoreItems = () => {
    //console.log("🚀 ~ loadMoreItems ~ queryNestPassHistoryData?.queryNestPass?.totalCount <= (10 * (pageNumber+1):", queryNestPassHistoryData?.queryNestPass?.totalCount , (10 * (pageNumberRef?.current)))
    if (isLoadingMoreRef?.current) return;
    if(queryNestPassHistoryData?.queryNestPass?.totalCount <= (10 * (pageNumberRef?.current))) return;
    try{
      fetchMore({
        variables: {
          "limit": 10 ,
          skip: 10 * pageNumberRef?.current,
        },
      });
    }
    catch(error){
    }
  };

  // const handleScroll1 = () => {
  //   //console.log(window.innerHeight, window.scrollY , document.documentElement.scrollHeight , window.innerHeight * 0.2)
  //   if (window.innerHeight + window.scrollY >= (document.documentElement.scrollHeight - (window.innerHeight * 0.5)) && !loadingMore) {
  //     loadMoreItems()
  //   }
  // };

  const handleScroll = () => {
    const divElement = scrollDivRef.current;
    if (
      divElement &&
      divElement.scrollTop + divElement.clientHeight >= divElement.scrollHeight - divElement.clientHeight * 0.2 &&
      !loadingMore
    ) {
        loadMoreItems();
    }
  };


//   React.useEffect(() => {
//     if (!ordersDataLoading && queryNestPassHistoryData) {
//       if(queryNestPassHistoryData?.queryNestPass?.orders){
//         NestPassOrdersHistory = NestPassOrdersHistory.concat(queryNestPassHistoryData.queryNestPass?.orders)
//         setNestPassOrdersHistory(NestPassOrdersHistory);
//       }
//           isLoading = false
//           setIsLoading(isLoading)
//     }
// }, [queryNestPassHistoryData, ordersDataLoading]);

  const fetchOrderDetails = (item) => {
    // isLoading = true
    // setIsLoading(isLoading)
    OpenOrderDetailsModal(item)
  }

  const OrdersHistoryCards = ({item}) => {

    return  <div className={`hover:border-appThemeColorDark border-appThemeColorAboveLight border-2 shadow relative flex mb-3 p-2 bg-${colors?.backgroundColor} dark:bg-${colors?.backgroundColor}   rounded cursor-pointer`} 
      style={{backgroundColor:Colors.colorTheme[colors?.backgroundColor]}}
      onClick={()=>{fetchOrderDetails(item)}}>
      <div className='w-full mx-2'>
        <div className="flex justify-between "> {/* Add sm:mb-0 to make sure it aligns correctly on small screens */}
          <span className={`text-sm sm:text-sm md:text-md lg:text-md xl:text-md mr-1 text-${colors?.heading}`} style={{color:((item?.onlinePaymentStatus)==2?colors?.success:(item?.onlinePaymentStatus)>2?colors?.fail:colors?.pending),}}>Payment {CheckOnlinePaymentStatus(item?.onlinePaymentStatus)}</span>
          <span className={`text-sm sm:text-sm md:text-md lg:text-md xl:text-md font-bold mr-1 text-appThemeColorVeryDark`}>₹{item?.amount}</span>
        </div>
        <div className="text-left "> {/* Add sm:mb-0 to make sure it aligns correctly on small screens */}
          <span className={`text-sm sm:text-sm md:text-sm lg:text-sm xl:text-sm text-${colors?.heading}`}>{(item?.reason || item?.cancelledBy)}</span>
        </div>
          <FaChevronRight className={`absolute  bottom-1 right-1 text-${colors?.heading}  text-xs sm:text-xs md:text-sm lg:text-sm xl:text-sm`} />
      </div>
    </div>
  }

  const OpenOrderDetailsModal = (value)=>{
    // if(!value){initialDataload()}
    orderDetails = value
    setOrderDetails(orderDetails)
  }

  const formatOrderDate = (utcDate) => {
    //console.log("🚀 ~ formatOrderDate ~ utcDate:", utcDate)
    if(!utcDate){
      return 'Undefined'
    }
    const localDate = moment.utc(utcDate).utcOffset(330);
    //console.log("🚀 ~ formatOrderDate ~ localDate:", localDate)
    // const localDate = moment.utc(utcDate)
    const formattedDate = localDate.format('Do MMM YYYY');
    const formattedTime = localDate.format('hh:mm a');
    return `${formattedDate}, ${formattedTime}`;
  };

  const priceDetailAsObject = (prices) => {
    let data =  prices?.reduce((priceDetailOfAllCustomerTypes, { customerType, sellingPrice })=>{priceDetailOfAllCustomerTypes[customerType] = sellingPrice;return priceDetailOfAllCustomerTypes},{})
    return data
  }

  const OrderItem = ({item,index}) => {
    //console.log("🚀 ~ OrderItem ~ item:", item)
      let loginInfo = getCustomCookie('loginInfo')
      let customerType = loginInfo?.customerType!=undefined?loginInfo?.customerType:0

      // Use useMemo to memoize the result of the expensive calculation
      const priceDetailOfAllCustomerTypes = useMemo(() => priceDetailAsObject(item?.prices), [item]);
      //console.log("🚀 ~ OrderItem ~ priceDetailOfAllCustomerTypes:", priceDetailOfAllCustomerTypes)

  return <div key={`_${index}OrderSummary`} className="flex justify-between">
    <p className={`text-${colors?.heading} text-sm`}>{item.quantity} x {item.name} (₹{priceDetailOfAllCustomerTypes[customerType]})</p>
    <p className={`text-${colors?.heading} text-sm`}>
    <span className="line-through">₹{item.quantity * item.mrp}</span> ₹{item.quantity * priceDetailOfAllCustomerTypes[customerType]}
    </p>
  </div>
}

  const handleDownload = async () => { 
    try {
      const requestBody = {
        invoiceId: orderDetails?.invoiceId || "ORD-NNBLRLOCAL01-CC984-10069"
      };
  
      const { data: response } = await client.query({
        query: queryNestPassInvoice,
        variables: requestBody,
        fetchPolicy: 'no-cache',
      });
  
      const jsonString = atob(response?.queryInvoiceForNestPass);
      const jsonData = JSON.parse(jsonString);
      //console.log("🚀 ~ file: OrdersHistory.js ~ line 463 ~ handleDownload ~ jsonData", jsonData)
  
      // Render the HTML invoice from template
      const invoiceHtml = NestPassInVoiceTemplate({ invoice: jsonData });
      
      // Create a container for the invoice and apply a red border for testing
      const container = document.createElement('div');
      // container.style.border = '2px solid red';
      // // Optionally, set a fixed width (adjust as needed to match an A4 layout)
      // container.style.width = '750px';
      // container.style.overflow = 'auto'; // Or 'visible' if you prefer
      
      
      // IMPORTANT: Only set the innerHTML once with the full invoice content.
      container.innerHTML = invoiceHtml;
  
      // Append the container once to the body
      document.body.appendChild(container);
  
      // If your invoiceHtml output contains an element with id 'invoice'
      // use it; if not, use the container itself.
      const element = document.getElementById('invoice') || container;
  
      // Use devicePixelRatio for a better resolution if available.
      const scale = window.devicePixelRatio || 2;
      const canvas = await html2canvas(element, { 
        scale, 
        scrollX: 0, // or negative offset
        scrollY: -window.scrollY 
      });
  
      // Generate PDF from canvas image
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
  
      // Define margins
      const margin = 10; // 10mm margin
      const contentWidth = pdfWidth - margin * 2;
      const contentHeight = pdfHeight - margin * 2;
  
      // Get the image properties and calculate the aspect ratio.
      const imgProps = pdf.getImageProperties(imgData);
      const aspectRatio = imgProps.width / imgProps.height;
  
      // Determine dimensions that fit within the content area (without cropping)
      let width, height;
      if (aspectRatio > 1) {
        width = contentWidth;
        height = contentWidth / aspectRatio;
      } else {
        height = contentHeight;
        width = contentHeight * aspectRatio;
      }
  
      // Calculate coordinates to center the image within the PDF page.
      const x = margin + (contentWidth - width) / 2;
      const y = margin + (contentHeight - height) / 2;
  
      pdf.addImage(imgData, 'PNG', x, 30, width, height);
      pdf.save('invoice.pdf');
  
      // Clean up the appended HTML
      document.body.removeChild(container);
      
    } catch (error) {
      //console.log("HandleDownload error", error);
    }
  };
  

  return (
        <>
          <div ref={scrollDivRef} className='mt-2p pb-2 overflow-y-scroll hide-scroll-bar max-h-[90vh]'>
          {isLoading ?
            <div className='flex justify-center'><div className={`loader ease-linear rounded-full border-2 border-t-8 border-gray-200 h-10 w-10`}></div></div>:
              !orderDetails?(NestPassOrdersHistory?.length !=0?<div className='overflow-y-auto'>
                <div className={` border-appThemeColorDark border-2 shadow relative flex flex-row gap-2 mb-3 p-2 bg-${colors?.backgroundColor} dark:bg-${colors?.backgroundColor} rounded`} 
                    style={{backgroundColor:Colors.colorTheme[colors?.backgroundColor]}}>
                      <div className='flex-1 flex flex-col justify-center items-center'>
                        <div className={`text-md my-1 sm:text-md md:text-lg lg:text-lg xl:text-xl text-appThemeColorDark`}>₹{nestPassDataStats?.totalPurchaseAmount || 0}</div>
                        <div className={`my-1 text-sm sm:text-sm md:text-sm lg:text-sm xl:text-sm text-${colors?.heading}`}>{t('totalPurchaseAmount')}</div>
                      </div>
                      <div className='flex-1 flex flex-col justify-center items-center'>
                        <div className={`text-md my-1 sm:text-md md:text-lg lg:text-lg xl:text-xl text-appThemeColorDark`}>₹{nestPassDataStats?.totalSavedAmount || 0}</div>
                        {<div className={`my-1 text-sm sm:text-sm md:text-sm lg:text-sm xl:text-sm text-${colors?.heading}`}>{t('totalSavedAmount')}</div>}
                      </div>
                </div>
                <div className={`pb-1 text-sm font-semibold text-${colors?.heading}`}>Recent Activity</div>
              {
                NestPassOrdersHistory.map((item,index) => (
                  <div key={`_${index}NestPassOrdersHistory`} className=''><OrdersHistoryCards index={index} item={item} /></div>
                ))
              }
              </div>:
              <div className="flex h-96 items-center justify-center">
                <p className={`text-${colors?.heading}`}>No Purchase History</p>
              </div>
              ):
              <>  
              <div>
                <div className='flex align-center items-center justify-between'>
                  <div className={`flex align-center text-md sm:text-md md:text-md lg:text-xl xl:text-xl items-center gap-2 text-${colors?.heading} font-bold`}>
                    <FaArrowLeftLong className={`cursor-pointer text-lg sm:text-lg md:text-lg lg:text-2xl xl:text-2xl my-2 text-${colors?.heading}`} onClick={()=>OpenOrderDetailsModal(false)} />
                    <div className={`text-sm my-1 sm:text-sm md:text-sm lg:text-sm xl:text-sm text-${colors?.heading}`}>More Details</div>
                  </div>
                  {orderDetails?.invoiceId && <button className="bg-appThemeColorVeryDark text-white flex justify-between items-center rounded p-1p" onClick={handleDownload}>
                      <div className='flex flex-wrap items-center justify-center w-full' >
                        <span className="text-sm sm:text-sm md:text-md lg:text-md xl:text-md mx-1">Download Invoice</span>
                      </div>
                    </button>}
                </div>
                <div className={` border-appThemeColorAboveLight border-2 shadow relative flex flex-col mb-3 p-2 bg-${colors?.backgroundColor} dark:bg-${colors?.backgroundColor} rounded`} 
                    style={{backgroundColor:Colors.colorTheme[colors?.backgroundColor]}}>
                      <div className={`text-sm my-1 sm:text-sm md:text-sm lg:text-sm xl:text-sm text-${colors?.heading}`}>Payment Amount :{`₹${orderDetails?.amount}`}</div>
                      <div className={`my-1 text-sm sm:text-sm md:text-sm lg:text-sm xl:text-sm text-${colors?.heading}`}>Payment Mode : Online Using {(orderDetails?.onlinePaymentProvider)}</div>
                      <div className={`my-1 text-sm sm:text-sm md:text-sm lg:text-sm xl:text-sm text-${colors?.heading}`}>Payment Status : {CheckOnlinePaymentStatus(orderDetails?.onlinePaymentStatus)}</div>
                      {orderDetails?.canceledRefundStatus>0 && <div className={`my-1 text-sm sm:text-sm md:text-sm lg:text-sm xl:text-sm text-${colors?.heading}`}>Re-Fund Status : {CheckOnlinePaymentRefundStatus(orderDetails?.canceledRefundStatus)}</div>}
                </div>
                <div className={` border-appThemeColorAboveLight border-2 shadow relative flex mb-3 p-2 bg-${colors?.backgroundColor} dark:bg-${colors?.backgroundColor} rounded`} 
                    style={{backgroundColor:Colors.colorTheme[colors?.backgroundColor]}}>
                    {(orderDetails?.reason || orderDetails?.cancelledBy) && <div className={`text-sm my-1 sm:text-sm md:text-sm lg:text-sm xl:text-sm text-${colors?.heading}`}>{(orderDetails?.reason || orderDetails?.cancelledBy)}</div>}
                </div>
                {(orderDetails?.membershipDate || orderDetails?.membershipExpiryDate) &&<div className={` border-appThemeColorAboveLight border-2 shadow relative flex mb-3 p-2 bg-${colors?.backgroundColor} dark:bg-${colors?.backgroundColor} rounded`} 
                    style={{backgroundColor:Colors.colorTheme[colors?.backgroundColor]}}>
                      {orderDetails?.membershipDate && <div className={`text-sm my-1 sm:text-sm md:text-sm lg:text-sm xl:text-sm text-${colors?.heading}`}>Purchased On {formatOrderDate(orderDetails?.membershipDate)}</div>}
                      {orderDetails?.membershipExpiryDate && <div className={`text-sm my-1 sm:text-sm md:text-sm lg:text-sm xl:text-sm text-${colors?.heading}`}>Expries On {formatOrderDate(orderDetails?.membershipExpiryDate)}</div>}
                    
                </div>}
              </div>
              </>
          }
              {/* {orderDetails && <OrderDetails orderDetails={orderDetails} orderId={selectedOrder?._id} navigation={navigation} OpenOrderDetailsModal={OpenOrderDetailsModal} />} */}
          </div>
        </>
  )
}